<template>
    <base-page :title="$t('l.pay_account')" icon="logo-usd">
        <template slot="extra">
            <!--<Button type="primary">保存</Button>-->
            <Button @click="loadData">{{$t('l.fresh')}}</Button>
        </template>
        <template>
            <Row class="full" :gutter="10">
                <Col span="6" v-for="(depart, index_d) in departList">
                    <Card :title="depart.name">
                        <p slot="extra">{{depart.rolename}}</p>
                        <ul>
                            <li><Icon type="ios-contact" /> {{depart.realname}} <template v-if="depart.job_num">[{{depart.job_num}}]</template></li>
                            <li><Icon type="ios-phone-portrait" /> {{depart.mobile}}</li>
                            <li><Icon type="ios-mail" /> {{depart.email}}</li>
                            <li>
                                <Icon type="ios-card" />
                                <span> {{depart.pay_balance}} {{$t('l.unit2')}} </span>
                                <span>
                                    <InputNumber v-model="payValue" v-if="index_d === payIndex" :placeholder="$t('l.remark15')" :min="0" @on-blur="onMoneyChange"></InputNumber>
                                    <ButtonGroup :class="index_d === payIndex?'margin-top-10':''">
                                        <Button :type="index_d === payIndex?'primary':'warning'" @click="onPayClick(index_d)">{{$t('l.recharge')}}</Button>
                                        <Button v-if="index_d === payIndex" @click="payIndex = -1;">{{$t('l.cancel')}}</Button>
                                    </ButtonGroup>
                                </span>
                            </li>
                        </ul>
                    </Card>
                </Col>
            </Row>
        </template>
    </base-page>
</template>

<script>
    import BasePage from "../my-components/base-page";
    import util from '@/libs/util';

    export default {
        name: 'page-pay-account',
        components: {BasePage},
        data() {
            return {
                departList: [],
                payIndex: -1,
                payValue: 0,
                sendSMS: 0
            };
        },
        computed: {

        },
        methods: {
            loadData () {
                util.ajax.get('/depart/listofpay').then(res => {
                    this.departList = res.data;
                })
            },
            onPayClick (index) {
                if (this.payIndex === -1) {
                    this.payIndex = index;
                    this.payValue = 0;
                } else {
                    this.paySubmit();
                }
            },
            paySubmit () {
                if (!this.payValue) {
                    this.$Message.warning(this.$t('l.remark16'));
                    return;
                }
                let depart = this.departList[this.payIndex];
                let sendSMS = 0;
                this.$Modal.confirm({
                    title: this.$t('l.recharge'),
                    render: (h) => {
                        return h('div', [
                            h('p', [this.$t('l.remark17') + `【${depart.name}】 ` + this.$t('l.recharge') + ` `, h('b', this.onMoneyChange().toFixed(2)), ` ` + this.$t('l.unit2')]),
                            h('p', this.$t('l.remark18')),
                            h('p', {class: 'margin-top-10'}, [
                                h('Checkbox', {
                                    on: {
                                        input: (value) => {
                                            sendSMS = value ? 1 : 0;
                                        }
                                    }
                                }, this.$t('l.send_sms') +` ${depart.realname} (${depart.mobile})`)
                            ])
                        ])
                    },
                    onOk: () => {
                        util.ajax.get('/getSessionKey').then(res => {
                            if (res.code) return;
                            util.ajax.put('/depart/recharge',
                                {data: util.encrypt(JSON.stringify({
                                        id: depart.id,
                                        value: this.payValue,
                                        mobile: depart.mobile,
                                        sendSMS: sendSMS,
                                        company: depart.name
                                    }), res.data)}
                            ).then(res => {
                                if (!res.code) {
                                    this.$Modal.remove();
                                    this.$Message.success(this.$t('l.recharge_success'));
                                    depart.pay_balance += this.payValue;
                                    this.payIndex = -1;
                                    this.payValue = 0;
                                }
                            })
                        })

                    },
                    onCancel: () => {
                        this.$Modal.remove();
                    }
                })
            },
            onMoneyChange () {
                this.payValue = Math.floor(this.payValue * 100) / 100;
                return this.payValue;
            }
        },
        created() {

        },
        mounted() {
            this.loadData();
        },
    };

</script>
<style scoped lang="less">

</style>
